import React, {Component} from "react";
import {InstitutionService} from "../../../../service/maintenance/institution/InstitutionService";
import {Button} from "primereact/button";
import {
    INSERT_CONTACT_ROUTE,
    INSERT_SIGN_ROUTE,
    MAINTENANCE_INSTITUTIONS_ROUTE,
    UPDATE_INSTITUTION_ROUTE
} from "../../../../utils/constants/RoutesConstants";
import UpdateInstitution from "./UpdateInstitutionView";
import {dateDDMMYY, strToDate} from "../../../../utils/formatters/Date";
import {isValidData} from "../../../../utils/validator/Fields";
import {Growl} from "primereact/growl";
import {deleteNonNumericPint, deleteSpecialChars, replaceDiacriticsUni} from "../../../../utils/formatters/Accent";
import ContextMenu from "../../../../components/contextMenu";


export default class UpdateInstitutionContainer extends Component {
    constructor(props) {
        super(props);
        let today = new Date();

        this.institutionService = new InstitutionService();

        this.selectedIndexSteps = this.selectedIndexSteps.bind(this);
        this.getCatalogsInstitution = this.getCatalogsInstitution.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveDataInstitution = this.saveDataInstitution.bind(this);
        this.saveDataCheckInstitution = this.saveDataCheckInstitution.bind(this);
        this.contactActionTemplate = this.contactActionTemplate.bind(this);
        this.deleteSignActionTemplate = this.deleteSignActionTemplate.bind(this);
        this.openAddContact = this.openAddContact.bind(this);
        this.openAddSigns = this.openAddSigns.bind(this);
        this.updateInstitution = this.updateInstitution.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.deleteSign = this.deleteSign.bind(this);
        this.getInstitution = this.getInstitution.bind(this);
        this.goNextStep = this.goNextStep.bind(this);
        this.goPreviousStep = this.goPreviousStep.bind(this);
        this.saveDataPint = this.saveDataPint.bind(this);
        this.saveDataAlphaNum = this.saveDataAlphaNum.bind(this);

        this.state = {
            isEditableRS: false,
            today: today,
            isLoading: true,
            returnPath: this.props.location.state.returnPath,
            getInstitution: this.getInstitution(),
            activeIndex: this.props.location.state.activeIndex ? this.props.location.state.activeIndex : 0,
            catalogs: this.getCatalogsInstitution(),
            items: [
                {
                    label: 'Institución',
                },
                {
                    label: 'Medios de Comunicación',
                },
                {
                    label: 'Firmas Autorizadas',
                },
                {
                    label: 'Documentación',
                }
            ],
            dialogSign: {},
            institution:
                this.props.location.state.institution ? this.props.location.state.institution :
                    {
                        catInstitution: '',
                        nombreCorto: '',
                        catTypeLoan: '',
                        catRole: '',
                        catInstrument: '',
                        catStatus: '',
                        catRoleType: '',
                        catSignType: '',
                        catIdType: '',
                        catIdClientGss: '',
                        catIdCounterpartGss: '',
                    },
            contactList: this.props.location.state.contactList ? this.props.location.state.contactList : [],
            signList: this.props.location.state.signList ? this.props.location.state.signList : [],
            requiredFields: ['catInstitution', 'nombreCorto','catTypeLoan', 'catInstrument', 'catRole', 'catStatus',
                'razonSocial', 'rfc', 'numEscCon', 'recPubComer', 'powerNumber'],
            requiredFieldsFis: ['fisCalle', 'fisColonia', 'fisCP', 'fisCiudad', 'fisEstado', 'fisPais',],
            requiredFieldsCorr: ['corrCalle', 'corrColonia', 'corrCP', 'corrCiudad', 'corrEstado', 'corrPais'],
            requiredFieldsDoc: ['idInst', 'folioInst']
        };
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    getInstitution() {
        this.loading();
        return this.props.location.state.institution ? this.props.location.state.institution :
        this.institutionService.getInstitution(this.props.location.state.institutionId).then(res => {
            let contactListRest = [];
            let signListRest = [];
            let institutionRest;
            let clientGssRest = {};
            let counterPartGssRest = {};

            if (this.state.contactList.length === 0) {
                res[1].forEach(
                    contact => {
                        let newContact = {
                            idTipoMedioComunica: contact.IdTipoMedioComunica,
                            tipoMedioComunica: contact.DescrTipoMedioComunica,
                            decripcionMedioComunica: contact.DescrMedioComunica,
                            idRolContacto: contact.IdRolContacto,
                            rolContacto: contact.DescripcionRolContacto,
                            contactoOperativo: contact.ContactoOperativo,
                            seleccionContactoOperativo: contact.BanderaContacto
                        };
                        contactListRest.push(newContact);
                    }
                );
            } else {
                contactListRest = this.state.contactList;
            }

            if (this.state.signList.length === 0) {
                res[2].forEach(
                    sign => {
                        let newSign = {
                            apellidoPaterno: sign.ApePatFirma,
                            apellidoMaterno: sign.ApeMatFirma,
                            nombre: sign.NomFirma,
                            idTipoFirma: sign.IdTipoFirma,
                            tipoFirma: sign.DescrTipoFirma,
                            idIdentificacion: sign.IdIdentificacion,
                            identificacion: sign.DescrIdentificacion,
                            fechaVencimiento: dateDDMMYY(sign.FecVenc),
                        };
                        signListRest.push(newSign);
                    }
                );
            } else {
                signListRest = this.state.signList;
            }

            institutionRest = {
                idInstitucion: res[0].idInstitucion,
                razonSocial: res[0].razonSocial,
                nombreCorto: res[0].nombreCorto,
                counterBBVAId: res[0].counterBBVAId,
                rfc: res[0].rfc,
                contrato: res[0].contrato,
                seleccionGaran: res[0].seleccionGaran === 1,
                numEscCon: res[0].numEscCons,
                escrituraFec: strToDate(res[0].fecEsc),
                recPubComer: res[0].regPubComer,
                regPubFec: strToDate(res[0].fecRegPub),
                powerNumber: res[0].noPoder,
                powerDate: strToDate(res[0].fecPoder),
                fisCalle: res[0].fisCalle,
                fisColonia: res[0].fisColonia,
                fisCP: res[0].fisCP,
                fisCiudad: res[0].fisCiudad,
                fisEstado: res[0].fisEstado,
                fisPais: res[0].fisPais,
                corrCalle: res[0].corrCalle,
                corrColonia: res[0].corrColonia,
                corrCP: res[0].corrCP,
                corrCiudad: res[0].corrCiudad,
                corrEstado: res[0].corrEstado,
                corrPais: res[0].corrPais,
                contratoServicios: res[0].contratoServicios === 1,
                comprobanteDomicilio: res[0].comprobanteDomicilio,
                poderesNotariales: res[0].poderesNotariales === 1,
                actaConstitutiva: res[0].actaConstitutiva === 1,
                comprobanteRFC: res[0].comprobanteRFC === 1,
                idInst: res[0].idInst,
                folioInst: res[0].folioInst,
                banderaCuentaEfvo: res[0].banderaCuentaEfvo === '1',
                cuentaEfectivo: res[0].cuentaEfectivo,
                banderaIndeval: res[0].banderaIndeval === 1,
                observaciones: res[0].observaciones,
                idContraparte: res[0].idContraparte,
                catInstitution: {
                    IdInstFinan: '',
                    NomInstFinanCorto: ''
                },
                catTypeLoan: {
                    id: res[0].idOtc + "",
                    descripcionId: res[0].descriptionOtc,
                },
                catRole: {
                    IdRol: res[0].idRol * 1,
                    DescripcionRol: res[0].descripcionRol,
                },
                catInstrument: {
                    IdTipoInstrumento: res[0].idTipoInstrumento * 1,
                    DescripcionInstrumento: res[0].descripcionInstrumento,
                },
                catStatus: {
                    id: res[0].status,
                    descripcionId: res[0].status ? "Alta" : "Baja",
                },
                catIdClientGss: clientGssRest,
                catIdCounterpartGss: counterPartGssRest,
            };
            this.setState({
                isLoading: false,
                idClienteGSS: res[0].idClienteGSS,
                idContraparte: res[0].idContraparte,
                contactList: contactListRest,
                signList: signListRest,
                institution: institutionRest,
                getInstitution: res,
            })
        })
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: MAINTENANCE_INSTITUTIONS_ROUTE,
            message: message,
        });
    }

    selectedIndexSteps(event, newIndexAux) {
        let indexAux = this.state.activeIndex;
        let newIndex = !isNaN(event.index) ? event.index : newIndexAux;

        switch (indexAux) {
            case 0:
                if (!isValidData(this.state.requiredFields, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar los campos requeridos correctamente'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            case 1:
                if (!isValidData(this.state.requiredFieldsFis, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar todos los campos de dirección fiscal'
                    });
                } else if (!isValidData(this.state.requiredFieldsCorr, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar todos los campos de dirección correspondencia'
                    });
                } else if (this.state.contactList.length === 0) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe al menos tener un contacto.'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            case 2:
                if (this.state.signList.length === 0) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe al menos tener una firma autorizada.'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            case 3:
                if (!isValidData(this.state.requiredFieldsDoc, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar los campos requeridos correctamente'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            default:
                break;
        }
        this.setState({activeIndex: indexAux,});
    }

    goNextStep(){
        this.selectedIndexSteps("", this.state.activeIndex + 1);
    }

    goPreviousStep(){
        this.selectedIndexSteps("", this.state.activeIndex - 1);
    }

    openAddContact(rowdata) {
        this.props.history.push({
            pathname: INSERT_CONTACT_ROUTE,
            state: {
                returnPath: UPDATE_INSTITUTION_ROUTE,
                actionScreen: 'Edición de Institución',
                institution: this.state.institution,
                contactList: this.state.contactList,
                signList: this.state.signList,
                roleType: this.state.catalogs[2],
                contactType: this.state.catalogs[1],
                contactData: rowdata
            },
        });
    }

    openAddSigns() {
        this.props.history.push({
            pathname: INSERT_SIGN_ROUTE,
            state: {
                returnPath: UPDATE_INSTITUTION_ROUTE,
                actionScreen: 'Edición de Institución',
                institution: this.state.institution,
                contactList: this.state.contactList,
                signList: this.state.signList,
                signType: this.state.catalogs[3],
                idType: this.state.catalogs[4],
            },
        });
    }

    deleteContact(rowData) {
        this.setState({
            contactList: this.state.contactList.filter((val, i) =>
                val !== rowData
            )
        });
    }

    deleteSign(rowData) {
        this.setState({
            signList: this.state.signList.filter((val, i) =>
                val !== rowData
            )
        });
    }

    contactActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar ", action: () => this.openAddContact(rowData)},
            {label: "Eliminar", action: () => this.deleteContact(rowData)}
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    deleteSignActionTemplate(rowData) {
        return <Button type="button"
                       iconPos="left"
                       label="Eliminar"
                       style={{marginRight: '.5em'}}
                       className="p-button-secondary"
                       onClick={() => this.deleteSign(rowData)}
        />;
    }

    getCatalogsInstitution() {
        this.loading();
        return this.institutionService.getCatalogsInstitution().then(resp => {
            let res = resp.payload
            if (resp.error !== '') {
                this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
            } else {
                let clientGssRest='';
                let counterpartGssRest='';
                let institution = this.state.institution;
                let catInstAux = res[0].find(item => item['IdInstFinan'].toString() === institution.counterBBVAId);
                institution['catInstitution'] = catInstAux === undefined ?
                    {NomInstFinanCorto: institution.nombreCorto} : catInstAux;

                if (institution['catIdClientGss'] === "" || institution['catIdClientGss'].IDRELCLIENTE === undefined){
                    res[7].forEach(item => {
                        if (item.IDRELCLIENTE === this.state.idClienteGSS) {
                            clientGssRest = item;
                        }
                    });
                    institution['catIdClientGss'] = clientGssRest;
                }
                if(institution['catIdCounterpartGss'] === "" || institution['catIdCounterpartGss'].brokerCode === undefined){
                    res[8]['contraparte'].forEach(item => {
                        if (item.brokerCode === this.state.idContraparte) {
                            counterpartGssRest = item;
                        }
                    });
                    institution['catIdCounterpartGss'] = counterpartGssRest;
                }
                /**
                 * Diferenciación entre Fideicomiso BBVA y Banamex:
                 * Si el catálogo de intituciones trae en su primer elemento la razón social, NO es editable
                 *
                 */
                let isEditableRaS = res[0].length === 0 || res[0][0]['NomInstFinan'] === undefined;

                this.setState({
                    catalogs: res,
                    institution: institution,
                    isEditableRS: isEditableRaS,
                });
            }
            this.setState({
                isLoading: false,
            });
        });
    }

    saveDataInstitution(event) {
        let {name, value} = event.target;
        let institution = this.state.institution;
        if (value === null){
            value = "";
        }
        institution[name] = value;
        this.setState({institution: institution,})
    }
    saveDataAlphaNum(event){
        let {name, value} = event.target;
        let institution = this.state.institution;
        if (value === null){
            value = "";
        }
        institution[name] = deleteSpecialChars(replaceDiacriticsUni(value));
        this.setState({institution: institution,})
    }

    saveDataPint(event){
        let {name, value} = event.target;
        let institution = this.state.institution;
        if (value === null){
            value = "";
        }
        institution[name] = deleteNonNumericPint(value);
        this.setState({institution: institution,})
    }

    saveDataCheckInstitution(event) {
        const {name, checked} = event.target;
        let institution = this.state.institution;
        institution[name] = checked;
        this.setState({institution: institution,})
    }

    updateInstitution() {
        if (!isValidData(this.state.requiredFields, this.state.institution)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Debe llenar los campos de requeridos de la pestaña institución, correctamente'
            });
        } else if (this.state.contactList.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Agregar por lo menos un medio de contacto'
            });
        } else if (this.state.signList.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Agregar por lo menos una firma'
            });
        } else if (!isValidData(this.state.requiredFieldsDoc, this.state.institution)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Debe llenar los campos requeridos de la pestaña documentación correctamente'
            });
        } else {
            this.institutionService.updateInstitution(
                this.state.institution,
                this.state.contactList,
                this.state.signList, true
            ).then(res => {
                let messageObj = {};
                if (res.message !== '') {
                    messageObj['severity'] = 'success';
                    messageObj['sumary'] = 'Éxito';
                    messageObj['detail'] = res.message === 'Success' ?
                        'Se ha actualizado su solicitud con éxito' :
                        res.message;
                    this.handleReturnButton(messageObj);
                } else if (res.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
                }
            });
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return (
            <UpdateInstitution
                messagesGrowl={messagesGrowl}
                isLoading={this.state.isLoading}
                displayDialogContacts={this.state.displayDialogContacts}
                displayDialogSigns={this.state.displayDialogSigns}
                closeDialogContacts={this.closeDialogContacts}
                closeDialogSigns={this.closeDialogSigns}
                updateInstitution={this.updateInstitution}
                handleReturnButton={this.handleReturnButton}
                contactActionTemplate={this.contactActionTemplate}
                deleteSignActionTemplate={this.deleteSignActionTemplate}
                saveDataInstitution={this.saveDataInstitution}
                saveDataAlphaNum={this.saveDataAlphaNum}
                saveDataPint={this.saveDataPint}
                saveDataCheckInstitution={this.saveDataCheckInstitution}
                activeIndex={this.state.activeIndex}
                items={this.state.items}
                selectedIndexSteps={this.selectedIndexSteps}
                institution={this.state.institution}
                businessName={this.state.catalogs[0]}
                catInstitution={this.state.institution.catInstitution}
                typeLoan={this.state.catalogs[9]}
                catTypeLoan={this.state.institution.catTypeLoan}
                role={this.state.catalogs[5]}
                catRole={this.state.institution.catRole}
                instrument={this.state.catalogs[6]}
                catInstrument={this.state.institution.catInstrument}
                status={this.state.catalogs[10]}
                catStatus={this.state.institution.catStatus}
                contactType={this.state.catalogs[1]}
                catContactType={this.state.institution.catContactType}
                roleType={this.state.catalogs[2]}
                catRoleType={this.state.institution.catRoleType}
                signType={this.state.catalogs[3]}
                catSignType={this.state.institution.catSignType}
                idType={this.state.catalogs[4]}
                catIdType={this.state.institution.catIdType}
                idClientGss={this.state.catalogs[7]}
                catIdClientGss={this.state.institution.catIdClientGss}
                idCounterpartGss={this.state.catalogs[8] !== undefined ? this.state.catalogs[8]['contraparte'] : []}
                catIdCounterpartGss={this.state.institution.catIdCounterpartGss}
                contact={this.state.institution.contact}
                sign={this.state.institution.sign}
                contactList={this.state.contactList}
                signList={this.state.signList}
                today={this.state.today}
                isEditableRS={this.state.isEditableRS}
                openAddContact={this.openAddContact}
                openAddSigns={this.openAddSigns}
                goNextStep={this.goNextStep}
                goPreviousStep={this.goPreviousStep}
            />)
    }
}